// src/blogs/amazon-books.js
export const frontmatter = {
  slug: "amazon-books",
  title: "The Story Behind My Amazon Books",
  date: "2025-06-30",
  summary: "Discover the inspiration, message, and purpose behind my Amazon-published titles.",
};

export const content = `
# The Story Behind My Amazon Books

Publishing books has been more than a creative journey — it's been a calling to encourage, uplift, and empower others. Through Amazon's Kindle Direct Publishing (KDP), I’ve been able to turn my thoughts into print, and my experiences into words that speak to others.

## 📘 [The Courage to Begin](https://www.amazon.com/dp/B0D2SRFZRM)

This was my debut book — a heartfelt push to help readers take that first step. Whether you're starting a new career, moving to a new city, or simply daring to be more of who you are, _The Courage to Begin_ is your companion. It teaches that fear doesn't mean you're not ready — it means you're on the edge of something meaningful.

> “You don’t need to have it all figured out. You just need the courage to take the next right step.”

## 🌟 [The Art of Choosing Joy](https://www.amazon.com/dp/B0D5MJJKYN)

This book was written as a gentle reminder that **joy is not the absence of pain**, but a decision we make despite it. It’s a guide to mindfulness, gratitude, and intentional living. In a fast-paced world that demands perfection, _The Art of Choosing Joy_ invites you to breathe, slow down, and reclaim peace.

> “Joy isn’t found. It’s chosen — moment by moment, breath by breath.”

## 💡 Why I Write

I write because I believe stories — especially those rooted in truth — can change lives. Each page I pen is a reflection of the lessons I’ve learned and the ones I’m still learning.

## 📚 What's Next?

I’m working on more titles that continue this journey of **growth**, **resilience**, and **purpose**. My mission is simple: to offer words that help others stand up, breathe deeper, and keep moving forward.

---

📖 Thank you for reading, and even more for sharing in the journey.  
Explore my books on Amazon and be part of this unfolding story.
`;
